import React from 'react';

interface BillsSummaryProps {
  totalBills: number;
  totalAmountDue: number;
}

const BillsSummary: React.FC<BillsSummaryProps> = ({ totalBills, totalAmountDue }) => {
  return (
    <div className="bills-summary-section mb-6 w-full">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Your Bills</h2>
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 w-full">
        {/* Total Bills Card */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-10 hover:shadow-lg transition-all duration-300 hover:scale-105 min-h-[160px]">
          <div className="flex items-center h-full">
            <div className="w-20 h-20 bg-purple-100 rounded-xl flex items-center justify-center mr-8 flex-shrink-0">
              <svg 
                className="w-10 h-10 text-purple-600" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" 
                />
              </svg>
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-base font-medium text-gray-600 mb-3 uppercase tracking-wide">Total Bills</p>
              <p className="text-5xl font-bold text-gray-900">{totalBills}</p>
              <p className="text-sm text-gray-500 mt-2">Pending payment</p>
            </div>
          </div>
        </div>

        {/* Total Amount Due Card */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-10 hover:shadow-lg transition-all duration-300 hover:scale-105 min-h-[160px]">
          <div className="flex items-center h-full">
            <div className="w-20 h-20 bg-orange-100 rounded-xl flex items-center justify-center mr-8 flex-shrink-0">
              <span className="text-4xl font-bold text-orange-600">$</span>
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-base font-medium text-gray-600 mb-3 uppercase tracking-wide">Total Amount Due</p>
              <p className="text-5xl font-bold text-gray-900">${totalAmountDue.toFixed(2)}</p>
              <p className="text-sm text-gray-500 mt-2">Outstanding balance</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillsSummary;
